<template>
  <div class="calico-score-meter">
    <div class="score">
      <ClicoMeter :color="mode === 'light' ? '#0000001A' : '#FFFFFF40'" />
      <ClicoMeter
        :percentage="score"
        :color="color"
      />
    </div>
    <span
      v-if="score !== null"
      :class="['display--small', mode]"
    >{{ score }}</span>
    <span
      v-else
      :class="['display--small', mode]"
    >--</span>
    <label :class="['label--xsmall', mode]">{{ title || 'No Score' }}</label>
  </div>
</template>

<script>
import ClicoMeter from '@/components/calico/meter/index.vue'
export default {
    name: "CalicoScoreMeter",
    components: {
        ClicoMeter
    },
    props: {
        score: {
            type: Number,
            default: null
        },
        title: {
            type: String,
            default: ""
        },
        mode: {
            type: String,
            default: "dark"
        }
    },
    data() {
        return {
            currentStateIndex: 0,
            states: [
                [0, '#181719'],
                [10, '#8B0E38'],
                [30, '#FF5C00'],
                [50, '#E9FA20'],
                [60, '#FF03BE'],
                [70, '#4C00E0'],
                [80, '#21D8CF'],
                [90, '#0EF180'],
                [101, '', ''],
            ]
        }
    },
    computed: {
        color() {
            const index = this.states.findIndex(state => Number(state[0]) > this.score)
            return this.states[index - 1][1]
        }
    }
};
</script>

<style lang="scss">
.calico-score-meter {
    position: relative;
    @include stack-space($space-none);
    width: 150px;
    height: 150px;
    color: $color-white;
    justify-content: center;
    text-align: center;

    .score {
        position: absolute;
        width: 150px;
        height: 150px;
        .calico-meter {
            left: 0;
        }
    }

    .light {
        color: $color-text-primary;
    }
}
</style>